/**
 * Global fetch interceptor — automatically adds JWT Authorization header.
 * Import this once in App.js before any fetch calls happen.
 * Skips portal auth endpoints to avoid token conflicts.
 */
const originalFetch = window.fetch;

window.fetch = function (url, options = {}) {
  const token = localStorage.getItem('token');
  const urlStr = typeof url === 'string' ? url : url?.url || '';

  // Don't add CRM token to portal auth endpoints or public endpoints
  const isPortalAuth = urlStr.includes('/api/portal/');
  const isAuthEndpoint = urlStr.includes('/api/auth/login') || urlStr.includes('/api/auth/register');

  if (token && !isPortalAuth && !isAuthEndpoint) {
    const headers = options.headers instanceof Headers
      ? options.headers
      : new Headers(options.headers || {});

    if (!headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    options.headers = headers;
  }
  return originalFetch(url, options);
};

export const getToken = () => localStorage.getItem('token');
export const setToken = (token) => localStorage.setItem('token', token);
export const clearToken = () => localStorage.removeItem('token');
